import {
  BurgerAndLogoBlock,
  HeaderContainer,
  HeaderContainerSlim,
} from "./styled";
import logo from "../../assets/logo.png";
import HeaderButtonsRow from "./header-buttons";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  getCountries,
  getCurrencies,
  getLanguages,
} from "../../redux/slices/static-data.slice";
import BurgerButton from "./header-buttons/burger-button/burger-button";
import { changeSidebarIsOpen } from "../../redux/slices/sidebar.slice";
import { changeDevice } from "../../redux/slices/device.slice";
import { useMediaQuery, useTheme } from "@mui/material";
import { getCurrentUserData } from "../../redux/slices/current-user.slice";
import { onLogoClick } from "../shared/helper-functions";
import { UserGroups } from "../../router/router";

const Component = ({
  isAdmin,
  isWarehouseWorker,
  isLocalWarehouseWorker,
  hasValidatedRecipient,
}: HeaderProps) => {
  const { isLoggedIn } = useAppSelector((state) => state.loginReducer);
  const { isOpen } = useAppSelector((state) => state.sidebarReducer);
  const { currentUser } = useAppSelector((state) => state.currentUserReducer);
  const isPdr =
      currentUser?.userGroup.userGroupId === UserGroups.PARCEL_DELIVERY_REQUEST;

  const [isReady, setIsReady] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const matchesPc = useMediaQuery(theme.breakpoints.up(1500));
  const matchesTablet =
    useMediaQuery(theme.breakpoints.between(1200, 1500)) &&
    window.innerHeight > 500;
  const matchesPhone =
    useMediaQuery(theme.breakpoints.between(0, 1200)) ||
    window.innerHeight <= 500;

  const isInLoginPage =
    location.pathname.includes("/login") ||
    location.pathname.includes("/register") ||
    location.pathname.includes("/recover") ||
    location.pathname.includes("/change-password") ||
    location.pathname.includes("/account-activation");

  useEffect(() => {
    dispatch(changeSidebarIsOpen(matchesPc || matchesTablet || false));
    dispatch(changeDevice({ matchesPc, matchesTablet, matchesPhone }));
  }, [matchesPhone, matchesTablet, matchesPc]);

  useEffect(() => {
    isInLoginPage ? Promise.resolve() : dispatch(getCurrentUserData());
  }, [isInLoginPage]);

  useEffect(() => {
    Promise.allSettled([
      dispatch(getLanguages()),
      dispatch(getCountries()),
      dispatch(getCurrencies()),
    ]).then(() => setIsReady(true));
  }, []);

  const BarekamLogo = () => (
    <img
      onClick={() =>
        onLogoClick(
          !!isAdmin,
          !!isWarehouseWorker,
          !!isLocalWarehouseWorker,
          currentUser,
          dispatch,
          navigate,
        )
      }
      className={"logo"}
      src={logo}
      style={{
        height: matchesPc || matchesTablet ? "3rem" : "2.5rem",
        cursor: "pointer",
      }}
      alt={""}
    />
  );

  if (isInLoginPage) {
    return (
      <HeaderContainer>
        <BarekamLogo />
        <HeaderButtonsRow
          withUserData={false}
          isAdmin={false}
          isWarehouseWorker={
            isWarehouseWorker || isLocalWarehouseWorker || false
          }
          isPdr={isPdr || false}
          hasValidatedRecipient={false}
          isDesktop={matchesPc}
          isTablet={matchesTablet}
        />
      </HeaderContainer>
    );
  } else if (matchesPc) {
    if (!isOpen) {
      dispatch(changeSidebarIsOpen(true));

      return <></>;
    }

    return (
      <HeaderContainer>
        <BarekamLogo />

        {isReady ? (
          <HeaderButtonsRow
            withUserData={isLoggedIn}
            isAdmin={isAdmin || false}
            isWarehouseWorker={
              isWarehouseWorker || isLocalWarehouseWorker || false
            }
            isPdr={isPdr || false}
            hasValidatedRecipient={!!hasValidatedRecipient}
            isDesktop={matchesPc}
            isTablet={matchesTablet}
          />
        ) : (
          <></>
        )}
      </HeaderContainer>
    );
  } else if (matchesTablet) {
    return (
      <HeaderContainer>
        <BurgerAndLogoBlock>
          <BurgerButton />

          <BarekamLogo />
        </BurgerAndLogoBlock>

        {isReady ? (
          <HeaderButtonsRow
            withUserData={isLoggedIn}
            isAdmin={isAdmin || false}
            isWarehouseWorker={
              isWarehouseWorker || isLocalWarehouseWorker || false
            }
            isPdr={isPdr || false}
            hasValidatedRecipient={!!hasValidatedRecipient}
            isDesktop={matchesPc}
            isTablet={matchesTablet}
          />
        ) : (
          <></>
        )}
      </HeaderContainer>
    );
  } else {
    return (
      <HeaderContainerSlim>
        <BurgerAndLogoBlock>
          <BurgerButton />
        </BurgerAndLogoBlock>

        {isReady ? (
          <HeaderButtonsRow
            withUserData={isLoggedIn}
            isAdmin={isAdmin || false}
            isWarehouseWorker={
              isWarehouseWorker || isLocalWarehouseWorker || false
            }
            isPdr={isPdr || false}
            hasValidatedRecipient={!!hasValidatedRecipient}
            isDesktop={matchesPc}
            isTablet={matchesTablet}
          />
        ) : (
          <></>
        )}
      </HeaderContainerSlim>
    );
  }
};

export interface HeaderProps {
  isAdmin?: boolean;
  isWarehouseWorker?: boolean;
  isLocalWarehouseWorker?: boolean;
  hasValidatedRecipient?: boolean;
}

const Header = React.memo(Component);

export default Header;
